import { useEffect } from "react";
import "./login.scss";
import LoginForm from "./LoginForm";
import { deactivateDemo } from "src/demo/demoApi";
export default function Login() {
    useEffect(() => {
        deactivateDemo();
    }, []);

    return (
        <div className="login-page">
            <div className="login-card-wrapper">
                <LoginForm />
            </div>

            <div className="login-art">
                <div className="login-art__content">
                    <div className="login-art__motto">
                        <div className="login-art__line">
                            <span className="login-art__line-inner">Selbst abrechnen kostet Zeit.</span>
                        </div>
                        <div className="login-art__line">
                            <span className="login-art__line-inner">Auslagern kostet Umsatz.</span>
                        </div>
                        <div className="login-art__line login-art__motto-strong">
                            <span className="login-art__line-inner">Medinvoice spart beides.</span>
                        </div>
                    </div>

                    <div className="login-art__tablet" aria-hidden="true">
                        <div className="login-art__tablet-float">
                            <div className="login-art__tablet-bezel">
                                <div className="login-art__tablet-screen">
                                    <div className="login-art__ui-header">
                                        <div className="login-art__ui-brand">
                                            <span className="login-art__ui-dot" />
                                            <span className="login-art__ui-brand-name">Medinvoice</span>
                                        </div>
                                        <div className="login-art__ui-icons">
                                            {Array.from({ length: 6 }).map((_, i) => (
                                                <span key={i} className="login-art__ui-icon" />
                                            ))}
                                            <span className="login-art__ui-pill" />
                                        </div>
                                    </div>

                                    <div className="login-art__ui-body">
                                        <div className="login-art__ui-hero">
                                            <div className="login-art__ui-hero-left">
                                                <div className="login-art__ui-hero-kicker">Willkommen zurück</div>
                                                <div className="login-art__ui-hero-title">Dashboard</div>
                                                <div className="login-art__ui-hero-sub">Total Outstanding</div>
                                                <div className="login-art__ui-hero-value">€ 12.840,75</div>
                                                <div className="login-art__ui-hero-bar">
                                                    <span className="login-art__ui-hero-bar-fill" />
                                                </div>
                                            </div>
                                            <div className="login-art__ui-hero-stats">
                                                {["Pending", "Sent", "Paid", "Overdue"].map((t) => (
                                                    <div key={t} className="login-art__ui-hero-stat">
                                                        <div className="login-art__ui-hero-stat-label">{t}</div>
                                                        <div className="login-art__ui-hero-stat-value">€ 2.340,00</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="login-art__ui-grid">
                                            <div className="login-art__ui-card">
                                                <div className="login-art__ui-card-title">Übersicht</div>
                                                <div className="login-art__ui-mini-grid">
                                                    {Array.from({ length: 6 }).map((_, i) => (
                                                        <div key={i} className="login-art__ui-mini" />
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="login-art__ui-card">
                                                <div className="login-art__ui-card-title">Status offene Posten</div>
                                                <div className="login-art__ui-donut">
                                                    <span />
                                                </div>
                                            </div>
                                            <div className="login-art__ui-card">
                                                <div className="login-art__ui-card-title">Offene To-dos</div>
                                                <div className="login-art__ui-rows">
                                                    {Array.from({ length: 5 }).map((_, i) => (
                                                        <div key={i} className="login-art__ui-row" />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
